.graphContainer {
  position: relative;
  width: 100%;
  height: 16rem;
}
